export default __webpack_public_path__ + "static/media/bears-get-sniped.6802fec5.jpeg";